import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Icon from "@material-ui/core/Icon";

const columns = [
  { id: "name", label: "Name", minWidth: 170 },
  { id: "code", label: "ISO\u00a0Code", minWidth: 100 },
  {
    id: "population",
    label: "Population",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "Size\u00a0(km\u00b2)",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "density",
    label: "Density",
    minWidth: 170,
    align: "right",
    format: (value) => value.toFixed(2),
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

const rows = [
  createData("India", "IN", 1324171354, 3287263),
  createData("China", "CN", 1403500365, 9596961),
  createData("Italy", "IT", 60483973, 301340),
  createData("United States", "US", 327167434, 9833520),
  createData("Canada", "CA", 37602103, 9984670),
  createData("Australia", "AU", 25475400, 7692024),
  createData("Germany", "DE", 83019200, 357578),
  createData("Ireland", "IE", 4857000, 70273),
  createData("Mexico", "MX", 126577691, 1972550),
  createData("Japan", "JP", 126317000, 377973),
  createData("France", "FR", 67022000, 640679),
  createData("United Kingdom", "GB", 67545757, 242495),
  createData("Russia", "RU", 146793744, 17098246),
  createData("Nigeria", "NG", 200962417, 923768),
  createData("Brazil", "BR", 210147125, 8515767),
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 360,
  },
});
const renderPropsAreEqual = (prevProps, nextProps) => {
  let returnData = true;
  if (JSON.stringify(prevProps) === JSON.stringify(nextProps)) {
    returnData = true;
  } else {
    returnData = false;
  }
  return returnData;
};
const TableList = (props) => {
  const { ...param } = props;
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table size="small" stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                style={{
                  color: "#fff",
                  backgroundColor: "#115293",
                }}
              >
                Action
              </TableCell>
              {param.columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    minWidth: column.minWidth,
                    color: "#fff",
                    backgroundColor: "#115293",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {param.dataList.map((row, index) => {
              let backgroundColor = undefined;
              let color = undefined;

              if (row.validator_remarks == "VALID") {
                backgroundColor = "#27ae60";
                color = "#fff";
              } else if (row.validator_remarks == "INVALID") {
                backgroundColor = "#e74c3c";
                color = "#fff";
              }
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                  <TableCell>
                    <Icon
                      onClick={() => param.handleOpen(row, index)}
                      style={{
                        color: "#115293",
                        cursor: "pointer",
                      }}
                    >
                      launched
                    </Icon>
                  </TableCell>
                  {param.columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell
                        style={{
                          backgroundColor: backgroundColor,
                          color: color,
                        }}
                        key={column.id}
                        align={column.align}
                      >
                        {column.format && typeof value === "number"
                          ? column.format(value)
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={param.totalCount}
        rowsPerPage={param.rowsPerPage}
        page={param.page}
        onChangePage={param.handleChangePage}
        onChangeRowsPerPage={param.handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default React.memo(TableList, renderPropsAreEqual);
